export default class CreateGeneralLedgerMappingsRequest {
    enabled: boolean = true;
    transactionSourceGLId: string;
    savingsPortfolioControlGLId: string;
    savingsInterestExpenseGLId: string;
    savingsInterestPayableGLId: string;
    savingsFeeIncomeGLId: string;
    state: string = 'ACTIVE';
}